import { render, staticRenderFns } from "./ReportProductCardexAmount.vue?vue&type=template&id=5775e3fd&"
import script from "./ReportProductCardexAmount.vue?vue&type=script&lang=js&"
export * from "./ReportProductCardexAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports